module.exports = __webpack_public_path__ + "static/img/1-3.1b59ac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-1/1-3.jpg
// module id = 727
// module chunks = 1